
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class McSyncTests extends Vue {
    created() {
    }

    mounted() {
    }
  }
